import { X } from "lucide-react";
import { NOTE_TEMPLATES, type NoteTemplate } from "../utils/note-templates";

/** Modal shown when creating a new note — pick a starting template. */
export function TemplatePicker({
  onPick,
  onClose,
}: {
  onPick: (template: NoteTemplate) => void;
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md overflow-hidden rounded-2xl border border-white/[0.08] bg-[#111417] shadow-2xl shadow-black/50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-white/[0.06] px-4 py-3">
          <span className="text-sm font-black tracking-tight text-[#e7e9ea]">
            New note
          </span>
          <button
            onClick={onClose}
            aria-label="Close"
            className="rounded-md p-1 text-[#71767b] transition hover:bg-white/[0.05] hover:text-[#e7e9ea]"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="grid grid-cols-2 gap-2 p-3">
          {NOTE_TEMPLATES.map((t) => (
            <button
              key={t.id}
              onClick={() => onPick(t)}
              className="flex flex-col items-start gap-1 rounded-xl border border-white/[0.06] bg-white/[0.02] p-3 text-left transition hover:border-[#ff6b8f]/40 hover:bg-white/[0.04]"
            >
              <span className="text-xl">{t.emoji}</span>
              <span className="text-sm font-bold text-[#e7e9ea]">{t.label}</span>
              <span className="text-[11px] leading-tight text-[#71767b]">{t.hint}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
